/** Single source of truth for business details (NAP), links and nav. */

export const site = {
  name: 'Nikhil Jewellers',
  legalName: 'Nikhil Jewellers',
  since: 1951,
  tagline: 'Kundan, Polki & Diamond Jewellery',
  city: 'Ahmedabad',

  phone: '098243 53331',
  phoneHref: 'tel:+919824353331',
  whatsappHref: 'https://wa.me/919824353331',

  email: 'nikhiljewellers80@gmail.com',
  emailHref: 'mailto:nikhiljewellers80@gmail.com',

  address: {
    line1: '305, Ten Eleven Building',
    line2: 'C G Road',
    city: 'Ahmedabad',
    state: 'Gujarat',
    postalCode: '380006',
    country: 'IN',
  },
  addressOneLine:
    '305, Ten Eleven Building, C G Rd, Ahmedabad, Gujarat 380006',

  hours: [
    { days: 'Monday — Saturday', time: '11:00 am — 8:00 pm' },
    { days: 'Sunday', time: 'By appointment' },
  ],

  social: {
    instagram:
      'https://www.instagram.com/nikhiljewellersahmedabad?igsh=MWZkdzhyc2pvNmg5aw==',
    facebook: 'https://www.facebook.com/share/18yjokhUwB/?mibextid=wwXIfr',
    map: 'https://share.google/hY6yU2LAmnKYBy43U',
    website: 'https://www.nikhiljewellers.com/',
  },

  developer: {
    name: 'Shreepati Systems',
    url: 'https://www.shreepatisystems.com/',
  },
};

/** Secondary links, shown in the footer's bottom bar. */
export const legalNav = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
];

/** Primary navigation. `end` marks routes that must match exactly. */
export const nav = [
  { label: 'Home', to: '/', end: true },
  { label: 'Collections', to: '/collections' },
  { label: 'Lookbook', to: '/lookbook' },
  { label: 'Runway', to: '/runway' },
  { label: 'Heritage', to: '/heritage' },
  { label: 'Visit Us', to: '/visit' },
];

/**
 * Enquiry helper — pre-fills WhatsApp so a customer arrives in the shop's inbox
 * already telling them which piece they were looking at.
 */
export function whatsappEnquiry(subject) {
  const text = subject
    ? `Hello Nikhil Jewellers, I would like to enquire about: ${subject}`
    : 'Hello Nikhil Jewellers, I would like to enquire about your collections.';
  return `${site.whatsappHref}?text=${encodeURIComponent(text)}`;
}
